import { useCallback } from "react";

export const useScroller = () => {
    const scrollToComponent = useCallback((id: string) => {
        document.getElementById(id)?.scrollIntoView({
            behavior: "smooth",
        });
    }, []);

    const scrollToTop = useCallback(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return {
        scrollToComponent,
        scrollToTop,
    };
};
